<script lang="ts">
  import { page } from "$app/stores";
  import type { Editor } from "@tiptap/core";
  import { onMount } from "svelte";

  /**
   * Wraps a content block and tracks which heading was last scrolled into view
   * passing that heading down into the slot as `currentHeading`.
   *
   * Needs to be placed after the content as it traverses the dom from its point of view.
   */
  export let editor: Editor;

  let elem: HTMLElement;
  let currentHeading = "";
  let observer: IntersectionObserver;
  let hash: string;

  onMount(() => {
    hash = $page.url.hash;

    // wait until editor content ready
    editor.on("create", () => {
      const parentElement = elem?.parentElement?.parentElement;
      const content: Element[] =
        // @ts-ignore
        parentElement?.firstChild?.firstChild?.children;
      if (content && content.length) {
        // set up observer
        observer = new IntersectionObserver(
          (entries) =>
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                currentHeading = entry.target.id;
              }
            }),
          { rootMargin: "0px 0px -70% 0px" } // top 30% of page
        );
        // filter content for headings only and observe
        let headings: { id: string }[] = [];
        for (let i = 0; i < content.length; i++) {
          const node = content[i];
          const isHeadingNode = !!node.getAttribute("heading-type");
          if (isHeadingNode) {
            headings.push(node);
            observer.observe(node);
          }
        }

        if (headings.length) {
          // if url hash exists, set current heading to that
          // this is for when navigating from a different page directly from the link
          if (hash) {
            currentHeading = hash.substring(1);
          }
          // otherwise set the first heading as default
          else {
            currentHeading = headings[0].id;
          }
        }
      }
    });
    // cleanup intersection observer on unmount
    return () => observer?.disconnect();
  });
</script>

<div bind:this={elem} class="contents">
  <!-- pass current heading to slot for rendering active state -->
  <slot {currentHeading} />
</div>
